// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Card from "../Card/Card.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Modal from "../Modal/Modal.bs.js";
import * as React from "react";
import * as Ethers from "../../Ethers.bs.js";
import * as Spring from "../../react-spring/Spring.bs.js";
import * as Ethers$1 from "ethers";
import * as $$Promise from "@ryyppy/rescript-promise/src/Promise.bs.js";
import * as AnimButton from "./AnimButton.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as AppModuleCss from "./App.module.css";
import * as CamlinternalLazy from "rescript/lib/es6/camlinternalLazy.js";

var s = AppModuleCss;

function App$default(Props) {
  var ethereum = CamlinternalLazy.force(Ethers.ethereum);
  var address = "0xCDb6A538756c773f4518A723aB5E27F703f4C4d6";
  var match = React.useState(function () {
        return false;
      });
  var setModal = match[1];
  var match$1 = React.useState(function () {
        
      });
  var setWallet = match$1[1];
  var wallet = match$1[0];
  var match$2 = React.useState(function () {
        return 0;
      });
  var setTransactionPending = match$2[1];
  var transactionPending = match$2[0];
  var match$3 = React.useState(function () {
        return [];
      });
  var setWaves = match$3[1];
  var waves = match$3[0];
  var match$4 = React.useState(function () {
        return "";
      });
  var setMessage = match$4[1];
  var message = match$4[0];
  React.useEffect((function () {
          if (wallet === undefined) {
            return ;
          }
          if (ethereum === undefined) {
            return ;
          }
          var signer = new (Ethers$1.providers.Web3Provider)(Caml_option.valFromOption(ethereum)).getSigner();
          var contract = new Ethers$1.Contract(address, Ethers.abi.abi, signer);
          var handleWave = function (waver, timestamp, message, won) {
            return Curry._1(setWaves, (function (arr) {
                          return Belt_Array.concat([{
                                        waver: waver,
                                        message: message,
                                        timestamp: timestamp,
                                        won: won
                                      }], arr);
                        }));
          };
          contract.on("newWave", handleWave);
          contract.getAllWaves().then(function (arr) {
                return Curry._1(setWaves, (function (param) {
                              return Belt_Array.reverse(arr);
                            }));
              });
          return (function (param) {
                    contract.off("newWave", handleWave);
                    
                  });
        }), [
        wallet,
        address,
        ethereum,
        setWaves
      ]);
  React.useEffect((function () {
          if (ethereum !== undefined) {
            Ethers.request(Caml_option.valFromOption(ethereum), "eth_accounts").then(function (accounts) {
                  return Curry._1(setWallet, (function (param) {
                                return Belt_Array.get(accounts, 0);
                              }));
                });
          }
          
        }), [
        ethereum,
        setWallet
      ]);
  var connectWallet = function (param) {
    if (ethereum !== undefined) {
      $$Promise.$$catch(Ethers.request(Caml_option.valFromOption(ethereum), "eth_requestAccounts").then(function (accounts) {
                return Curry._1(setWallet, (function (param) {
                              return Belt_Array.get(accounts, 0);
                            }));
              }), (function (e) {
              return Promise.resolve((window.alert(e), undefined));
            }));
    } else {
      window.alert("Get metamask!");
    }
    
  };
  var openModal = function (param) {
    if (ethereum !== undefined && wallet !== undefined) {
      return Curry._1(setModal, (function (param) {
                    return true;
                  }));
    }
    
  };
  var submitMessage = function (param) {
    if (ethereum === undefined) {
      return ;
    }
    if (wallet === undefined) {
      return ;
    }
    var ethereum$1 = Caml_option.valFromOption(ethereum);
    $$Promise.$$catch(Promise.resolve(Curry._1(setTransactionPending, (function (x) {
                          return x + 1 | 0;
                        }))).then(function (param) {
                  var signer = new (Ethers$1.providers.Web3Provider)(ethereum$1).getSigner();
                  var contract = new Ethers$1.Contract(address, Ethers.abi.abi, signer);
                  return contract.wave(message);
                }).then(function (txn) {
                return txn.wait();
              }), (function (e) {
              console.log(e);
              window.alert("The transaction got rejected :(");
              return Promise.resolve(undefined);
            })).then(function (param) {
          Curry._1(setTransactionPending, (function (x) {
                  return x - 1 | 0;
                }));
          return Curry._1(setModal, (function (param) {
                        return false;
                      }));
        });
    
  };
  return React.createElement("div", {
              className: s.main
            }, React.createElement(Modal.make, {
                  handleClose: (function (param) {
                      return Curry._1(setModal, (function (param) {
                                    return false;
                                  }));
                    }),
                  isOpen: match[0],
                  children: null
                }, React.createElement("h3", undefined, "Drop me a message if you'd like"), React.createElement("textarea", {
                      className: s.message,
                      value: message,
                      onChange: (function (e) {
                          return Curry._1(setMessage, (function (param) {
                                        return e.target.value;
                                      }));
                        })
                    }), React.createElement("button", {
                      className: s.message_btn,
                      onClick: submitMessage
                    }, "👋 Wave")), React.createElement("div", {
                  className: s.header
                }, React.createElement("h1", {
                      className: s.h
                    }, "Hello there!"), React.createElement("div", {
                      className: s.header_btns
                    }, React.createElement(AnimButton.make, {
                          s: (function (h) {
                              return {
                                      display: "inline-block",
                                      marginRight: "1ch",
                                      transformOrigin: "bottom right",
                                      transform: h ? "rotate(-20deg) translateY(-0.2em)" : "rotate(0deg) translateY(0em)",
                                      config: Spring.Config.jello
                                    };
                            }),
                          emote: "👋",
                          className: s.btn + " " + (
                            transactionPending > 0 ? s.loading : ""
                          ) + " " + Belt_Option.mapWithDefault(wallet, s.disabled, (function (param) {
                                  return "";
                                })),
                          onClick: openModal,
                          children: "Wave at me"
                        }), React.createElement(AnimButton.make, {
                          s: (function (h) {
                              return {
                                      display: "inline-block",
                                      marginRight: "1ch",
                                      transform: h ? "rotate(25deg)" : "rotate(0deg)",
                                      config: Spring.Config.jello
                                    };
                            }),
                          emote: "💳",
                          className: s.btn + " " + (
                            transactionPending > 0 ? s.disabled : ""
                          ),
                          onClick: connectWallet,
                          children: "Connect your wallet"
                        })), React.createElement("p", {
                      className: s.counter
                    }, "I've been waved at " + String(waves.length) + " times")), React.createElement("div", {
                  className: s.content
                }, React.createElement("h2", undefined, "Latest waves"), React.createElement(React.Fragment, undefined, Belt_Array.mapWithIndex(waves, (function (idx, wave) {
                            return React.createElement(Card.make, {
                                        address: wave.waver,
                                        content: wave.message,
                                        timestamp: wave.timestamp,
                                        won: wave.won,
                                        key: String(idx)
                                      });
                          })))), React.createElement("footer", undefined, "© 2021 Nikodem Rabuliński"));
}

var $$default = App$default;

export {
  s ,
  $$default ,
  $$default as default,
  
}
/* s Not a pure module */
